import React from 'react'

export const NoAiFeatureFound = () => {
  return (
    <div className='no-result-container p-3 '>
      <span className='paragraph-medium'>Invalid preset configuration, please contact us at support@zocks.io</span>
    </div>
  )
}
